import { NgModule } from "@angular/core";
import { HomeComponent } from "./home/home.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MainCarouselComponent } from "./main-carousel/main-carousel.component";
import { PriceComponent } from "./products/price/price.component";
import { ProductsComponent } from "./products/products.component";
import { ProductComponent } from "./products/product/product.component";
import { ProductDetailsComponent } from "./products/product-details/product-details.component";
import { ProductDialogComponent } from "./products/product-dialog/product-dialog.component";
import { ProductLeftSidebarComponent } from "./products/product-left-sidebar/product-left-sidebar.component";
import { ProductVerticalComponent } from "./products/product-vertical/product-vertical.component";
import { CommonModule } from "@angular/common";
import { ShopRoutingModule } from "./shop-routing.module";
import { SharedModule } from "../shared/shared.module";
import { SwiperModule } from "ngx-swiper-wrapper";
import { FlexLayoutModule } from "@angular/flex-layout";
import { NgxPaginationModule } from "ngx-pagination";
import { HomeTwoComponent } from "./home-two/home-two.component";
import { HomeThreeComponent } from "./home-three/home-three.component";
import { NgxImageZoomModule } from "ngx-image-zoom";
import { ProductCarouselComponent } from "./../shop/home/product-carousel/product-carousel.component";
import { ProductCarouselTwoComponent } from "./home-two/product-carousel-two/product-carousel-two.component";
import { ProductCarouselThreeComponent } from "./home-three/product-carousel-three/product-carousel-three.component";
import { BrandsComponent } from "./widgets/brands/brands.component";
import { CategoriesComponent } from "./widgets/categories/categories.component";
import { PopularProductsComponent } from "./widgets/popular-products/popular-products.component";
import { HomeFourComponent } from "./home-four/home-four.component";
import { ProductZoomComponent } from "./products/product-details/product-zoom/product-zoom.component";
import { HomeFiveComponent } from "./home-five/home-five.component";
import { MatGridListModule } from "@angular/material";
import { ProductsInfoComponent } from "./products/products-info/products-info.component";
import { HomeSixComponent } from "./home-six/home-six.component";
import { CartDialogComponent } from "../pages/cart-dialog/cart-dialog.component";
import { ProformasEccComponent } from "./products/proformasEcc/proformas-ecc/proformas-ecc.component";
import { ProductSelectDialogComponent } from "./products/proformasEcc/product-select-dialog/product-select-dialog.component";
import { ProductDailogGifComponent } from "./products/product-details/product-dailog-gif/product-dailog-gif.component";
import { VistaPreviaListComponent } from "./vistaPrevia/vista-previa-list/vista-previa-list.component";
import { VistaPreviaDetailComponent } from "./vistaPrevia/vista-previa-detail/vista-previa-detail.component";
import { FilialDialogComponent } from "./Filial/filial-dialog/filial-dialog.component";
import { ProductV2Component } from "./products/product-v2/product-v2.component";
import { EstrellaCalificacionComponent } from "./products/product/estrella-calificacion/estrella-calificacion.component";

@NgModule({
  declarations: [
    HomeComponent,
    MainCarouselComponent,
    ProductsComponent,
    PriceComponent,
    ProductComponent,
    ProductDetailsComponent,
    ProductDialogComponent,
    CartDialogComponent,
    ProductLeftSidebarComponent,
    ProductVerticalComponent,
    HomeTwoComponent,
    HomeThreeComponent,

    ProductCarouselComponent,
    ProductCarouselTwoComponent,
    ProductCarouselThreeComponent,
    BrandsComponent,
    CategoriesComponent,
    PopularProductsComponent,
    HomeFourComponent,
    ProductZoomComponent,
    HomeFiveComponent,
    ProductsInfoComponent,
    HomeSixComponent,
    ProformasEccComponent,
    ProductSelectDialogComponent,
    ProductDailogGifComponent,
    VistaPreviaListComponent,
    VistaPreviaDetailComponent,
    FilialDialogComponent,
    ProductV2Component,
    EstrellaCalificacionComponent,
  ],
  imports: [
    CommonModule,
    ShopRoutingModule,
    SharedModule,
    SwiperModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    NgxPaginationModule,
    MatGridListModule,
    NgxImageZoomModule.forRoot(), // <-- Add this line
  ],
  exports: [
    ProductDialogComponent,
    CartDialogComponent,
    ProductSelectDialogComponent,
    ProductZoomComponent,
    ProductDailogGifComponent,
    FormsModule,
    FilialDialogComponent,
    EstrellaCalificacionComponent,
  ],

  entryComponents: [
    ProductDialogComponent,
    CartDialogComponent,
    ProductSelectDialogComponent,
    ProductZoomComponent,
    ProductDailogGifComponent,
    FilialDialogComponent,
  ],
})
export class ShopModule {}
